import { useEffect, useState } from 'react';
import { collectionGroup, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

const ACTIVE_WINDOW_MS = 90 * 1000; // 90s — matches presence ping cadence

/**
 * Live count of globally active users via collectionGroup('presence') filtered by lastActive in last 90s.
 * Used by emoji subsystem to switch between global and per-user-rooms mode.
 */
export const useGlobalLoad = (enabled = true) => {
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    const cutoff = Timestamp.fromDate(new Date(Date.now() - ACTIVE_WINDOW_MS));
    const q = query(collectionGroup(db, 'presence'), where('lastActive', '>', cutoff));
    const unsub = onSnapshot(q, (snap) => {
      const seenUsers = new Set();
      snap.docs.forEach(d => seenUsers.add(d.id));
      setActiveCount(seenUsers.size);
    }, () => setActiveCount(0));
    return unsub;
  }, [enabled]);

  return { activeCount };
};
